[file name]: Agreement.vue
<template>
	<!-- 遮罩层 -->
	<div v-if="visible" class="agreement-mask" @click="handleMaskClick">
		<!-- 弹窗内容 -->
		<div class="agreement-popup" @click.stop>
			<!-- 头部 -->
			<div class="popup-header">
				<span class="title">{{ currentAgreement === 'user' ? '用户协议' : '隐私政策' }}</span>
				<span class="close-icon" @click="close">×</span>
			</div>

			<!-- 内容区域 -->
			<div class="popup-content">
				<!-- 用户协议 -->
				<div v-if="currentAgreement === 'user'" class="agreement-content">
					<div class="section">
						<div class="section-title">一、服务声明</div>
						<div class="section-content">
							<div class="section-item">1. 本平台仅提供在线技术服务支持，包括但不限于信息展示、在线咨询、技术支持等服务。</div>
							<div class="section-item">2. <span
									class="highlight">特别声明：本平台不提供现场实勘服务，不参与项目现场评审。不承担实勘服务责任；提供评审后技术问题的修改，非技术问题不承担责任，不进行修改。</span>
							</div>
							<div class="section-item">3. 平台提供的技术服务以线上形式进行，用户应自行判断技术方案的适用性。</div>
						</div>
					</div>

					<div class="section">
						<div class="section-title">二、用户权利与义务</div>
						<div class="section-content">
							<div class="section-item">1. 用户有权使用平台提供的各项技术服务。</div>
							<div class="section-item">2. 用户应保证提供的信息真实、准确、完整。</div>
							<div class="section-item">3. 用户不得利用平台从事任何违法或侵犯他人权益的行为。</div>
							<div class="section-item">4. 用户应妥善保管账号信息，对账号下的所有操作负责。</div>
						</div>
					</div>

					<div class="section">
						<div class="section-title">三、服务限制</div>
						<div class="section-content">
							<div class="section-item">1. 平台服务仅限于线上技术支持，不包括：</div>
							<div class="subsection">
								<div class="subsection-item">- 现场勘查和测量</div>
								<div class="subsection-item">- 现场技术指导</div>
								<div class="subsection-item">- 项目现场评审</div>
								<div class="subsection-item">- 现场问题处理</div>
							</div>
							<div class="section-item">2. 对于需要现场服务的需求，用户应另行寻求专业现场服务机构。</div>
							<div class="section-item">3. 平台对用户线下实施项目的结果不承担任何责任。</div>
						</div>
					</div>

					<div class="section">
						<div class="section-title">四、免责条款</div>
						<div class="section-content">
							<div class="section-item">1. 因用户使用不当造成的损失，平台不承担责任。</div>
							<div class="section-item">2. 平台无法控制的技术问题（如网络中断、系统维护等）导致的服务中断，不承担责任。</div>
							<div class="section-item">3. <span class="highlight">平台对用户线下项目的实施结果、现场情况等不承担任何责任。</span>
							</div>
							<div class="section-item">4. 用户应自行对技术方案的风险进行评估和实施。</div>
						</div>
					</div>

					<div class="section">
						<div class="section-title">五、协议修改</div>
						<div class="section-content">
							<div class="section-item">1. 平台有权根据需要修改本协议。</div>
							<div class="section-item">2. 修改后的协议将在平台公示，继续使用服务视为接受修改。</div>
						</div>
					</div>
				</div>

				<!-- 隐私政策 -->
				<div v-if="currentAgreement === 'privacy'" class="agreement-content">
					<div class="section">
						<div class="section-title">一、信息收集</div>
						<div class="section-content">
							<div class="section-item">1. 为提供技术服务，我们会收集：</div>
							<div class="subsection">
								<div class="subsection-item">- 账号信息（用户名、密码）</div>
								<div class="subsection-item">- 联系方式（如提供）</div>
								<div class="subsection-item">- 技术需求信息</div>
								<div class="subsection-item">- 设备信息（用于优化服务）</div>
							</div>
							<div class="section-item">2. 我们不会收集与技术服务无关的个人隐私信息。</div>
						</div>
					</div>

					<div class="section">
						<div class="section-title">二、信息使用</div>
						<div class="section-content">
							<div class="section-item">1. 收集的信息仅用于：</div>
							<div class="subsection">
								<div class="subsection-item">- 提供和优化技术服务</div>
								<div class="subsection-item">- 技术支持沟通</div>
								<div class="subsection-item">- 安全保障</div>
								<div class="subsection-item">- 服务改进</div>
							</div>
							<div class="section-item">2. 我们不会将用户信息用于商业推广或出售给第三方。</div>
						</div>
					</div>

					<div class="section">
						<div class="section-title">三、信息安全</div>
						<div class="section-content">
							<div class="section-item">1. 我们采取合理措施保护用户信息安全。</div>
							<div class="section-item">2. 用户应妥善保管自己的账号密码。</div>
							<div class="section-item">3. 如发现信息泄露，请立即联系我们。</div>
						</div>
					</div>

					<div class="section">
						<div class="section-title">四、信息共享</div>
						<div class="section-content">
							<div class="section-item">1. 除非法律要求，我们不会共享用户信息。</div>
							<div class="section-item">2. 为提供技术服务需要时，可能会与必要的技术合作伙伴共享最小必要信息。</div>
						</div>
					</div>

					<div class="section">
						<div class="section-title">五、用户权利</div>
						<div class="section-content">
							<div class="section-item">1. 用户可以查询、更正个人信息。</div>
							<div class="section-item">2. 用户可以在注销账号时要求删除信息。</div>
							<div class="section-item">3. 用户可以拒绝非必要的个人信息收集。</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 底部按钮 -->
			<div class="popup-footer">
				<button type="button" class="cancel-btn" @click="close">关闭</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'agreement',
		props: {
			// 是否在注册场景中使用（显示确认按钮）
			isRegister: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				visible: false,
				currentAgreement: 'user' // 'user' 或 'privacy'
			};
		},
		methods: {
			// 打开弹窗
			open(type) {
				this.currentAgreement = type || 'user';
				this.visible = true;
			},

			// 关闭弹窗
			close() {
				this.visible = false;
			},

			// 点击遮罩层
			handleMaskClick(e) {
				if (e.target.classList.contains('agreement-mask')) {
					this.close();
				}
			},

			// 确认协议
			handleConfirm() {
				this.$emit('confirm');
				this.close();
			}
		}
	};
</script>

<style lang="less" scoped>
	.agreement-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
	}

	.agreement-popup {
		width: 90%;
		max-width: 700px;
		max-height: 80vh;
		background: #fff;
		border-radius: 12px;
		overflow: hidden;
		display: flex;
		flex-direction: column;

		.popup-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 20px 24px;
			border-bottom: 1px solid #f0f0f0;
			flex-shrink: 0;

			.title {
				font-size: 18px;
				font-weight: bold;
				color: #333;
			}

			.close-icon {
				font-size: 24px;
				color: #999;
				cursor: pointer;
				line-height: 1;

				&:hover {
					color: #666;
				}
			}
		}

		.popup-content {
			flex: 1;
			overflow-y: auto;
			padding: 20px 24px;

			.agreement-content {
				width: 100%;
			}

			.section {
				margin-bottom: 24px;
				width: 100%;

				&:last-child {
					margin-bottom: 0;
				}

				.section-title {
					display: block;
					font-size: 16px;
					font-weight: bold;
					color: #4b9efa;
					margin-bottom: 12px;
					word-break: break-word;
				}

				.section-content {
					display: flex;
					flex-direction: column;
					gap: 12px;
					width: 100%;

					.section-item {
						display: block;
						font-size: 14px;
						line-height: 1.6;
						color: #555;
						word-break: break-word;
						word-wrap: break-word;
						white-space: normal;
						text-align: left;

						.highlight {
							color: #e43d33;
							font-weight: bold;
							word-break: break-word;
						}
					}

					.subsection {
						display: flex;
						flex-direction: column;
						gap: 6px;
						margin-left: 20px;
						margin-top: 6px;
						margin-bottom: 6px;

						.subsection-item {
							display: block;
							font-size: 14px;
							line-height: 1.5;
							color: #666;
							word-break: break-word;
							text-align: left;
						}
					}
				}
			}
		}

		.popup-footer {
			display: flex;
			padding: 20px 24px;
			border-top: 1px solid #f0f0f0;
			gap: 16px;
			flex-shrink: 0;

			.cancel-btn {
				flex: 1;
				border: 1px solid #ddd;
				border-radius: 6px;
				font-size: 14px;
				color: #666;
				background: #fff;
				padding: 10px;
				cursor: pointer;
				transition: all 0.2s;

				&:hover {
					background: #f5f5f5;
					border-color: #ccc;
				}
			}

			.confirm-btn {
				flex: 1;
				border-radius: 6px;
				font-size: 14px;
				background: #4b9efa;
				color: #fff;
				border: none;
				padding: 10px;
				cursor: pointer;
				transition: all 0.2s;

				&:hover {
					background: #3a8ae5;
				}
			}
		}
	}

	/* 滚动条样式 */
	.popup-content::-webkit-scrollbar {
		width: 6px;
	}

	.popup-content::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	.popup-content::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;
	}

	.popup-content::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}
</style>